import React from 'react';
import { APP_NAV_ROUTES, HELP_ROUTES } from 'config/routes';
import Icon from '../Icon';
import styles from './NavSidebar.module.sass';
import cn from 'classnames';
import { useRouter } from 'next/router';
import NavLink from './NavLink';

export interface NavSidebarProps {
  visible: boolean;
  className?: string;
  onOpen: () => void;
  onClose: () => void;
}

const NavSidebar: React.FC<NavSidebarProps> = ({
  visible,
  className,
  onClose,
  onOpen,
}) => {
  const router = useRouter();

  return (
    <>
      <div
        className={cn(styles.navSidebar, className, {
          [styles.visible]: visible,
        })}
      >
        <div className={styles.header}>
          <button className={styles.close} onClick={onClose}>
            <Icon name="close" />
          </button>
          <a
            onClick={onClose}
            className={styles.logo}
            href="https://www.trend.io/"
            target="_blank"
            rel="noreferrer"
          >
            <img height={48} src="/images/trend-logo.svg" alt="trend-logo" />
          </a>
        </div>
        <div className={styles.menu}>
          <div>
            {Object.values(APP_NAV_ROUTES).map((route, index) => (
              <NavLink
                key={index}
                route={route}
                active={router.pathname === route.getPath()}
                onClose={onClose}
              />
            ))}
          </div>
          <div className={styles.foot}>
            <hr />
            <NavLink
              route={HELP_ROUTES.Help}
              active={HELP_ROUTES.Help.getPath() === router.pathname}
              onClose={onClose}
            />
            <NavLink
              route={HELP_ROUTES.AccountSettings}
              active={HELP_ROUTES.AccountSettings.getPath() === router.pathname}
              onClose={onClose}
            />
          </div>
        </div>
      </div>
      <div className={styles.iconMenu} onClick={onOpen}>
        <a
          onClick={onClose}
          className={styles.logo}
          href="https://www.trend.io/"
          target="_blank"
          rel="noreferrer"
        >
          <img height={48} src="/favicon.ico" alt="trend-logo" />
        </a>
        <div className={styles.menu}>
          <div>
            {Object.values(APP_NAV_ROUTES).map((route, index) => (
              <NavLink
                key={index}
                route={route}
                active={router.pathname === route.getPath()}
                onClose={onClose}
                iconOnly
              />
            ))}
          </div>
          <div className={styles.foot}>
            <hr />
            <NavLink
              route={HELP_ROUTES.Help}
              active={HELP_ROUTES.Help.getPath() === router.pathname}
              onClose={onClose}
              iconOnly
            />
            <NavLink
              route={HELP_ROUTES.AccountSettings}
              active={HELP_ROUTES.AccountSettings.getPath() === router.pathname}
              onClose={onClose}
              iconOnly
            />
          </div>
        </div>
      </div>
      <div
        className={cn(styles.navOverlay, className, {
          [styles.visible]: visible,
        })}
        onClick={onClose}
      />
    </>
  );
};

export default NavSidebar;
